export const actionTypes = {
    INITIAL_ORDER_FILTERS: 'INITIAL_ORDER_FILTERS',
    UPDATE_ORDER_FILTERS: 'UPDATE_ORDER_FILTERS',
    CLEAR_ORDER_FILTERS: 'CLEAR_ORDER_FILTERS',
    ORDER_LOADING_START: 'ORDER_LOADING_START',
    ORDER_LOADING_END: 'ORDER_LOADING_END',
    SAGA_FETCH_ORDERS: 'SAGA_FETCH_ORDERS',
    SAGA_FETCH_ORDERS_SUCCESS: 'SAGA_FETCH_ORDERS_SUCCESS',
    DISPATCH_CLEAR_ORDER_FILTERS: 'DISPATCH_CLEAR_ORDER_FILTERS',
    ORDER_ERROR: 'ORDER_ERROR',
}

export const initializeOrderFilters = filters => ({
    type: actionTypes.INITIAL_ORDER_FILTERS,
    payload: filters,
})

export const dispatchOrderFilters = filters => ({
    type: actionTypes.UPDATE_ORDER_FILTERS,
    payload: filters,
})

export const clearOrderFilters = () => ({
    type: actionTypes.CLEAR_ORDER_FILTERS,
})

export const OrdersLoadingStart = () => ({
    type: actionTypes.ORDER_LOADING_START,
})

export const OrdersLoadingEnd = () => ({
    type: actionTypes.ORDER_LOADING_END,
})

export const fetchOrders = data => ({
    type: actionTypes.SAGA_FETCH_ORDERS,
    payload: data,
})

export const fetchOrdersSuccess = data => ({
    type: actionTypes.SAGA_FETCH_ORDERS_SUCCESS,
    payload: data,
})

export const setOrderError = data => ({
    type: actionTypes.ORDER_ERROR,
    payload: data,
})

export const dispatchClearAllFilters = () => ({
    type: actionTypes.DISPATCH_CLEAR_ORDER_FILTERS,
})
